import { EXTERNAL_LOYALTY_PARTNERS } from "../../data/constants/shared";
import { defineProfile } from "./defaultProfile";

/**
 * Xeno — an external CRM partner. Legacy **class 1**, and the most divergent of the three: every
 * `isExternalProviderC1(...)` site in the old component was about this partner alone.
 *
 * Its coupon conversation reuses the LOYALTY redemption endpoint, so the whole envelope is
 * loyalty-shaped: the request body nests under `loyaltyInput`, success is
 * `redemptionInfo.success` rather than a `message`, and a `referenceId` arrives on the APPLY leg
 * which every later call — verify, and the unblock on removal — has to quote.
 *
 * ⚠️ `stampsExternalAuthentication: false` is a real difference, not an omission. Its OTP
 * verifies the OFFER, not the customer, so copying `authenticated` into `extAuthenticated` would
 * satisfy a customer-authentication gate that nobody passed. The old component expressed this as
 * `if (!isExternalProviderC1C2(...))`, which is the same rule read backwards.
 */
export const xenoProfile = defineProfile(EXTERNAL_LOYALTY_PARTNERS.XENO, {
  isExternalLoyalty: true,
  requiresCouponUnblock: true,
  unblockRequiresReferenceAndPhone: true,

  hasCouponModal: true,

  requiresOtpOnApply: true,
  honoursOfferOtpFlag: true,
  returnsItemLevelDiscounts: true,
  rollsBackUnappliedCoupon: true,
  sendsRequestId: true,

  verifyChannel: "loyalty-redeem",
  wrapsVerifyInLoyaltyInput: true,
  verifySuccessSignal: "redemption-info",
  stampsExternalAuthentication: false,
  referenceIdSource: "apply",
});
